import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import {
  AdminType,
  ChangeUserChainsCommand,
  CreateUserCommand,
  ResetPasswordCommand,
  User,
} from "../users/users.model";
import { FormBuilder, Validators } from "@angular/forms";
import { UsersService } from "../users/users.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { ChainsService } from "../chains/chains.service";
import { Chain } from "../chains/chains.model";
import { AdminEditComponent } from "../users/admin-edit/admin-edit.component";
import { finalize } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "app-chain-admins",
    templateUrl: "./chain-admins.component.html",
    styleUrls: ["./chain-admins.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChainAdminsComponent implements OnInit {
  private usersService = inject(UsersService);
  private chainsService = inject(ChainsService);
  private router = inject(Router);
  private formBuilder = inject(FormBuilder);
  dialog = inject(MatDialog);

  private adminsBS$ = new BehaviorSubject<User[]>([]);
  admins$ = this.adminsBS$.asObservable();
  selectedAdmin: User = null;
  chains: Chain[] = [];
  resettingPassword = false;
  selectedChainUuids: string[];

  hidePass = true;
  editChain = false;
  adminType: AdminType = AdminType.ChainAdmin;

  form = this.formBuilder.group({
    manualPassword: [false],
    password: [""],
    forceLogout: [false],
  });

  get passwordInput() {
    return this.form.controls.password;
  }

  ngOnInit(): void {
    this.loadChains();
    this.loadAdmins();
  }

  loadAdmins() {
    this.usersService.getChainAdmins().subscribe({
      next: (adm) => {
        this.adminsBS$.next(adm);
        if (this.selectedAdmin != null) {
          const idx = adm.findIndex((a) => a.uuid === this.selectedAdmin.uuid);
          if (idx !== -1) {
            this.selectedAdmin = adm[idx];
            this.selectedChainUuids = adm[idx].chains.map((ch) => ch.uuid);
            console.log(">>>>", this.selectedChainUuids);
          }
        }
      },
      error: () => console.log("ERROR when loading chain admins"),
    });
  }

  loadChains() {
    this.chainsService.getAllChains().subscribe((chns) => {
      this.chains = chns;
    });
  }

  clearForm() {
    this.hidePass = true;
    this.form.controls.manualPassword.setValue(false);
    this.form.controls.forceLogout.setValue(false);
    this.passwordInput.setValue("");
    this.passwordInput.clearValidators();
  }

  onBack() {
    this.router.navigate(["/"]).then();
  }

  onAddAdmin() {
    const dat = {
      type: AdminType.ChainAdmin,
      user: new User(),
    };
    const dialogRef = this.dialog.open(AdminEditComponent, {
      width: "40vw",
      data: dat,
    });
    dialogRef.afterClosed().subscribe((data: CreateUserCommand) => {
      if (data != null) {
        console.log("New chain Admin", data);
        this.usersService
          .addAdmin(data)
          .pipe(finalize(() => this.loadAdmins()))
          .subscribe();
      }
    });
  }

  resetPassword(uuid: string) {
    console.log("Reset password", uuid);
    const cr: ResetPasswordCommand = {
      userUuid: uuid,
      manualSetPassword: this.form.value.manualPassword,
      password: this.passwordInput.value,
      logoutUser: this.form.value.forceLogout,
    };
    this.usersService.resetUserPassword(cr).subscribe({
      next: () => {
        this.resettingPassword = false;
        this.clearForm();
      },
      error: () => {
        this.resettingPassword = false;
        this.clearForm();
        console.log("Password reset Error");
      },
    });
  }

  setManualPassword() {
    this.passwordInput.setValue("");
    if (this.form.value.manualPassword === true) {
      this.passwordInput.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.pattern("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$"),
      ]);
    } else {
      this.passwordInput.clearValidators();
    }

    this.passwordInput.updateValueAndValidity();
  }

  closeResetForm() {
    this.resettingPassword = false;
    this.clearForm();
  }

  onAdminSelected(user: User) {
    console.log("USER", user);
    this.selectedAdmin = user;
  }

  clearSelection() {
    this.selectedAdmin = null;
  }

  saveChain() {
    this.editChain = false;
    console.log("SAVE >>>>", this.selectedChainUuids);
    const command: ChangeUserChainsCommand = {
      chainsUuids: this.selectedChainUuids,
      userUuid: this.selectedAdmin.uuid,
    };

    this.usersService.changeChainForUser(command).subscribe((res) => {
      if (res === true) {
        this.loadAdmins();
      }
    });
  }

  closeEdit() {
    this.editChain = false;
  }

  getChainNames(user: User) {
    return user.chains.map((c) => c.name);
  }

  onEditChains() {
    this.selectedChainUuids = this.selectedAdmin.chains.map((ch) => ch.uuid);
    this.editChain = true;
  }
}
